import React from "react";
import type { SxProps, Theme } from "@mui/material";

export const useNewPropertyStyles = (): Record<string, SxProps<Theme>> => React.useMemo(
  () => ({
    section: { mt: 2 },
    quoteBox: { p: 2 },
  }),
  [],
);

export default useNewPropertyStyles;


